import React from "react";
import { History } from "lucide-react";
import { fmtDate } from "./helpers";

const ACTION_LABELS = {
  allowlist_add: { text: "Added", cls: "bg-emerald-100 text-emerald-700" },
  allowlist_remove: { text: "Removed", cls: "bg-red-100 text-red-700" },
  role_set: { text: "Role set", cls: "bg-[#F1EAFE] text-[#5D28C7]" },
  invite: { text: "Invited", cls: "bg-sky-100 text-sky-700" },
  suspend: { text: "Suspended", cls: "bg-amber-100 text-amber-700" },
  unsuspend: { text: "Unsuspended", cls: "bg-zinc-100 text-zinc-600" },
};

function ActionPill({ action }) {
  const a = ACTION_LABELS[action] || { text: action, cls: "bg-zinc-100 text-zinc-600" };
  return <span className={`inline-block ${a.cls} text-[10.5px] font-semibold uppercase tracking-wide px-1.5 py-0.5`}>{a.text}</span>;
}

function detailText(d) {
  if (!d) return "";
  const bits = [];
  if (d.role) bits.push(`role: ${String(d.role).replace(/_/g, " ")}`);
  if (d.type) bits.push(d.type);
  if (d.trial_days) bits.push(`${d.trial_days}d trial`);
  return bits.join(" · ");
}

export default function AccessAuditTable({ items }) {
  return (
    <section className="mb-10" data-testid="users-audit-section">
      <h3 className="text-[13px] font-semibold tracking-[0.16em] uppercase text-zinc-500 mb-3 flex items-center gap-2">
        <History size={14} /> Access audit
        <span className="text-zinc-400 normal-case tracking-normal">(last {items.length})</span>
      </h3>
      {items.length === 0 ? (
        <div className="bg-white border border-zinc-200 p-6 text-center text-zinc-500 text-[13px]">
          No access changes recorded yet. Adds, role changes, removals and suspensions will appear here.
        </div>
      ) : (
        <div className="overflow-x-auto bg-white border border-zinc-200">
          <table className="min-w-full text-[13px]">
            <thead className="bg-zinc-50 text-left text-zinc-500 text-[11px] uppercase tracking-[0.12em]">
              <tr>
                <th className="p-3">When</th>
                <th className="p-3">Action</th>
                <th className="p-3">Target</th>
                <th className="p-3">Details</th>
                <th className="p-3">By</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} className="border-t border-zinc-100" data-testid={`audit-row-${it.id}`}>
                  <td className="p-3 whitespace-nowrap text-zinc-600">{fmtDate(it.at)}</td>
                  <td className="p-3"><ActionPill action={it.action} /></td>
                  <td className="p-3 font-mono text-zinc-800">{it.target}</td>
                  <td className="p-3 text-zinc-600">{detailText(it.details)}</td>
                  <td className="p-3 text-zinc-600">{it.actor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
